export enum SettingsConfigType {
  String = 'string',
  Boolean = 'boolean',
  Number = 'number',
}
export interface Settings {
  id?: number;
  configKeyContext: string | null;
  configKeyDescription: string | null;
  configKey: string | null;
  configType: SettingsConfigType | null;
  configValue: string | null;
  encrypted: string | null;
  public: string | null;
  isEdit?: boolean;
}
export interface InitialData {
  tenantAliasId: string;
  fantasyName: string;
  socialName: string;
  document: string;
  description?: string;
}
export interface Domain {
  id?: number;
  isPrimary: boolean;
  domain: string | null;
}

export type TenantFormData = {
  initialData: InitialData;
  settings?: {
    add?: Settings[];
    edit?: Settings[];
    delete?: number[];
  };
  domains: {
    add?: Domain[];
    edit?: Domain[];
    delete?: number[];
  };
};

export type TenantFormTabs = keyof TenantFormData;
